

import { React, useRef, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import SecurityIcon from '@material-ui/icons/Security';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import './signin.scss'
import securityService from '../security.service';
import Alert from '@mui/material/Alert';
import moment from 'moment';
import SRC from './dalal-industries.jpeg'
import Cookies from 'js-cookie';
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import setupService from '../../../services/setup.service';
import SmartInvoicingLogo from './smart-invoicing-logo.svg';


const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        background: 'linear-gradient(135deg, #00a266 0%, #173b64 50%, #00a266 100%)',
        backgroundSize: '400% 400%',
        animation: '$gradientShift 15s ease infinite',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 40% 40%, rgba(255,255,255,0.05) 0%, transparent 50%)',
            pointerEvents: 'none'
        }
    },
    '@keyframes gradientShift': {
        '0%': {
            backgroundPosition: '0% 50%'
        },
        '50%': {
            backgroundPosition: '100% 50%'
        },
        '100%': {
            backgroundPosition: '0% 50%'
        }
    },
    paperRoot: {
        // background: 'rgba(255, 255, 255, 0.1)',
        background: 'rgba(33, 83, 110, 0.8)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 25px 45px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.05) inset',
        position: 'relative',
        zIndex: 1,
        margin: 'auto',
        maxWidth: '450px',
        padding: '40px 30px',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(0, 162, 102, 0.1) 0%, rgba(23, 59, 100, 0.1) 100%)',
            borderRadius: '24px',
            zIndex: -1
        }
    },
    image: {
        display: 'none'
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: '#fff',
        width: '100%'
    },
    avatar: {
        width: '70px',
        height: '70px',
        margin: theme.spacing(2),
        background: 'linear-gradient(135deg, #00a266 0%, #173b64 100%)',
        boxShadow: '0 8px 32px rgba(0, 162, 102, 0.3)',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        '& .MuiSvgIcon-root': {
            fontSize: '2rem'
        }
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(2)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        borderRadius: '50px',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        color: '#173b64',
        padding: '14px 40px',
        fontSize: '16px',
        fontWeight: '600',
        textTransform: 'none',
        border: 'none',
        boxShadow: '0 8px 25px rgba(255, 255, 255, 0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: 'linear-gradient(135deg, #00a266 0%, #173b64 100%)',
            color: '#ffffff',
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 35px rgba(0, 162, 102, 0.3)'
        },
        '&:active': {
            transform: 'translateY(0px)'
        }
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            transition: 'all 0.3s ease',
            '& fieldset': {
                border: 'none'
            },
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.3)'
            },
            '&.Mui-focused': {
                background: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.4)',
                boxShadow: '0 0 20px rgba(0, 162, 102, 0.3)'
            }
        },
        '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '14px',
            '&.Mui-focused': {
                color: '#ffffff'
            }
        },
        '& .MuiOutlinedInput-input': {
            color: '#ffffff',
            fontSize: '14px',
            padding: '14px 16px'
        }
    },
    select: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            background: 'rgba(255, 255, 255, 0.1)',
            // background:'rgba(33, 83, 110, 0.8)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            transition: 'all 0.3s ease',
            '& fieldset': {
                border: 'none'
            },
            '&:hover': {
                background: 'rgba(255, 255, 255, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.3)'
            },
            '&.Mui-focused': {
                background: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.4)',
                boxShadow: '0 0 20px rgba(0, 162, 102, 0.3)'
            }
        },
        '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '14px',
            '&.Mui-focused': {
                color: '#ffffff'
            }
        },
        '& .MuiSelect-select': {
            color: '#ffffff',
            fontSize: '14px',
            padding: '14px 16px'
        },
        '& .MuiSvgIcon-root': {
            color: 'rgba(255, 255, 255, 0.8)'
        }
    },
    title: {
        color: '#ffffff',
        fontWeight: '600',
        fontSize: '24px',
        marginBottom: '1px',
        padding: '1px !important',
        textAlign: 'center',
        textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    },
    logo: {
        width: '350px',
        height: 'auto',
        filter: 'drop-shadow(0 6px 20px rgba(0, 0, 0, 0.15))',
        transition: 'transform 0.3s ease',
        display: 'block',
        paddingLeft: '16px',
        '&:hover': {
            transform: 'scale(1.02)'
        }
    },
    logoContainer: {
        width: '280px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
    },
    logoBackground: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '20px 30px',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.6)'
        }
    },
    securityBadge: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        marginBottom: theme.spacing(2),
        padding: '16px 24px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        '& .MuiSvgIcon-root': {
            color: '#4caf50',
            fontSize: '20px'
        },
        '& span': {
            color: 'rgba(255, 255, 255, 0.9)',
            fontSize: '14px',
            fontWeight: '500'
        }
    }
}));

// Custom menu props for the dropdown to match glass morphism theme
const menuProps = {
    PaperProps: {
        style: {
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(20px)',
            borderRadius: '12px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            marginTop: '8px',
            maxHeight: '300px'
        }
    },
    MenuListProps: {
        style: {
            padding: '8px'
        }
    }
};

export default function SignInSide(props) {
    let FooterStyle=<style>{   `
        footer.main-footer{
            background:${Cookies.get('login-bg-color')};
            color:white;
            }
            div:has(.main-footer){
                background:${Cookies.get('login-bg-color')};
                
            }
        `
    }</style>
    const classes = useStyles();
    const [authFail, setAuthFail] = useState(false);
    const [resetSuccessful, setResetSuccessful] = useState(false);
    const [passMatch, setPassMatch] = useState(true);
    const linkElem = useRef(null);
    const [isRemembered, setIsRemembered] = useState(false);
    const [isChangePassScreen, setIsChangePassScreen] = useState(false);
    const [isResetPassScreen, setIsResetPassScreen] = useState(false);
    const [username, setUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    
    
    
    
    const [company, setCompany] = useState([]);

    useEffect(()=>{
        localStorage.removeItem('ShowSaleChallan');
        (async () => {
    
          const ok = await securityService.getShowSaleChallan();
    
          localStorage.setItem('ShowSaleChallan', ok);
       
      })()
    })
    useEffect( async () => {
         localStorage.removeItem('login');
        isAuthenticated();
        setTimeout(()=>{
            document.querySelector('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-8.MuiGrid-grid-md-5').style.backgroundColor = Cookies.get('login-bg-color') || '#00cc67'
        },100)
        let getData = await setupService.getAll('Company');
            console.log(getData)
         setCompany(getData.data.recordset);
         if(getData?.data?.recordset && Array.isArray(getData.data.recordset) && getData.data.recordset.length > 0){
         let response = await securityService.getCompanyLogo(getData.data.recordset[0]?.CompanyNTNCNIC);
                    console.log(response);

                    let Logo  = response.data.logo;
                    localStorage.setItem('CompanyImage', Logo);
                    setCompanyLogo(Logo)

         } 

         //console.log(localStorage.getItem('company'))
         // localStorage.removeItem('company') 
//         if(localStorage.getItem('company') == undefined || localStorage.getItem('company') == null){
//         let data = [
// {id:1,	value:'FS'},SEET
// {id:2,	value:'PM'},
// {id:3,	value:'RS'},
// {id:4,	value:'BM'},
// {id:5,	value:'HH'},
// {id:6,	value:'PS'}
//         ]
//         setCompany(data)
//         localStorage.removeItem('company');
//         localStorage.setItem('company', JSON.stringify(data));
//     }else{
    //     let storedData = localStorage.getItem('company');
    //     console.log(storedData)
    // let data = storedData == 'undefined' || storedData == 'null' ? [] : JSON.parse(storedData) ;
    // console.log(data);
    //     setCompany(data)

    // }

    if(document.getElementById('username')){
        document.getElementById('username').focus()
    }

    }, [])
    const [selectedValue, setSelectedValue] = useState("");

    const handleChange = (event) => {
        event.preventDefault()
      setSelectedValue(event.target.value);
    };

    const handleSignInSubmit = (event) => {
        event.preventDefault();
        setTimeout(()=>{
            //document.querySelector('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-8.MuiGrid-grid-md-5').style.backgroundColor = Cookies.get('login-bg-color') || '#00cc67'
        },100)
        const data = new FormData(event.currentTarget);
        console.log(data.get('companyid'))
        if (data.get('remember')) {
            setIsRemembered(true);
        } else {
            setIsRemembered(false);
        }
        const loginDetails = {
            // username: data.get('username').toString().toUpperCase(),
            username: data.get('username').toString(),
            password: data.get('password').toString(),
            companyID:data.get('companyid')
        };
        setUsername(data.get('username'));
        securityService.authenticateUser(loginDetails).then((response) => {
            console.log('response: ', response);
            if (response?.data?.UserID) {
                if (response?.data?.IsTempPassword) {
                    setIsResetPassScreen(false);
                    setIsChangePassScreen(true);
                } else {
                    const loginInfo = {
                        username: data.get('username'),
                        userId: response?.data?.UserID,
                        time: moment().format('DD/MM/YYYY HH:mm:ss'),
                        remembered: data.get('remember') ? true : false,
                        ShopID:response.data?.ShopID,
                        CompanyID:response.data?.CompanyID,
                        CompanyName:response.data?.CompanyName,
                    }
                    signInUser(loginInfo);
                 localStorage.removeItem('company');
                 localStorage.removeItem('FurtherTaxValue');

         localStorage.setItem('company', JSON.stringify(response.data?.CompanyDataSource));
                //    getFurtherTaxValue(loginInfo?.CompanyID)
                   getFurtherTaxValue(loginInfo?.userId ,loginInfo?.CompanyID);
                //    getUserAccessList(loginInfo?.userId ,loginInfo?.CompanyID);
                    // setTimeout(linkElem.current.click(), 10000);
                    if(Cookies.get('ThemeNo')){
                        console.log(Cookies.get('ThemeNo'));
                }else{
                    console.log(Cookies.get('ThemeNo'))
                    Cookies.set('login-bg-color', '#009f60', { expires: 887 }); // Expires in 7 days
                    Cookies.set('login-tx-color', '#000', { expires: 887 }); // Expires in 7 days
                    Cookies.set('login-av-color', '#876f7acf', { expires: 887 })
                    Cookies.set('bgColor', '#009f60', { expires: 887 }); // Expires in 7 days
                    Cookies.set('txColor', '#000', { expires: 887 });  
                    Cookies.set('ThemeNo', '106', { expires: 887 });  
                    Cookies.set('condition', false, { expires: 887 });  
                    Cookies.set('modeColor', '#fff', { expires: 887 });  
                }
                }
            } else {
                setAuthFail(true);
                setTimeout(() => setAuthFail(false), 5000);
            }
        });
    };

    const handleResetPassword = (event) => {
        const data = new FormData(event.currentTarget);
        setTimeout(()=>{
            document.querySelector('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-8.MuiGrid-grid-md-5').style.backgroundColor = Cookies.get('login-bg-color') || '#00cc67'
        },100)
        const resetDetails = {
            username: data.get('username').toUpperCase(),
            email: data.get('email').toUpperCase(),
            password: Math.random().toString(36).slice(2),
            isTemp: 1
        };
        securityService.verifyEmail(resetDetails).then((response) => {
            if (response?.data?.recordset[0]?.verification) {
                // verified
                setIsResetPassScreen(false);
                setIsChangePassScreen(true);
                // setResetSuccessful(true);
                // setTimeout(() => setResetSuccessful(false), 5000);
                // securityService.emailSend({pass:resetDetails.password , email: resetDetails.email}).then(res=>{
                //     console.log(res)
                // })
            } else {
                setAuthFail(true);
                setTimeout(() => setAuthFail(false), 5000);
            }
        });
        event.preventDefault();
    };
    const [Iserror, setIserror] = useState(false);
    const handleChangePassword = (event) => {
        const data = new FormData(event.currentTarget);
        setTimeout(()=>{
            document.querySelector('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-8.MuiGrid-grid-md-5').style.backgroundColor = `${Cookies.get('login-bg-color')} !important` || '#00cc67'
            document.querySelector('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-8.MuiGrid-grid-md-5').style.backgroundColor = `${Cookies.get('login-bg-color')} !important` || '#00cc67'
        },100)
        const loginDetails = {
            username: username.toUpperCase(),
            password: data.get('newPassword'),
            isTemp: 0
        };
        if (loginDetails.password === data.get('rePassword') ) {
            securityService.changePassword(loginDetails)
                .then(() => {
                    // setIsResetPassScreen(false);
                    // setResetSuccessful(false);
                    // setTimeout(() => setResetSuccessful(false), 5000);
                    
                    // linkElem.current.click()
                    // const loginInfo = {
                    //     username: username.toUpperCase(),
                    //     time: moment().format('DD/MM/YYYY HH:mm:ss'),
                    //     remembered: isRemembered
                    // }
                    // signInUser(loginInfo);
                    // getUserAccessList(loginInfo?.userId);
                    // setAuthFail(false);
                    // setIsResetPassScreen(false);
                    setIsResetPassScreen(false)
                    setIsChangePassScreen(false)

                    // setTimeout(linkElem.current.click(), 5000);
                });
        } else {
            setPassMatch(false);
            setTimeout(() => setPassMatch(true), 5000);
        }
        event.preventDefault();
    };

    const isAuthenticated = () => {
        var authentication = localStorage.getItem('login');
        if (authentication !== null) {
            props.history.push('/home');
            // auth.login(()=> {
            //     // linkElem.current.click();
            //     props.history.push('/home');
            // })        
        }
    };
    // const rememberMeChange = (event) => {
    //     //event.preventDefault();
    //     console.log('remember me: ', event?.target?.checked);
    //     setIsRemembered(event?.target?.checked);
    // };

    const resetPassClickHandler = (event) => {
        setAuthFail(false);
        setIsResetPassScreen(true);
    };

    const backClickHandler = (event) => {
        setAuthFail(false);
        setIsResetPassScreen(false);
    };

    const signInUser = (loginInfo) => {
        // I don't think we need to clear all localstorage??
        // localStorage.clear();
        console.log(loginInfo)
        localStorage.removeItem('login');
        localStorage.setItem('login', JSON.stringify(loginInfo));
    }
    const isStrongPassword = (password) => {
        // Ensure the length is 8 characters or more
        const lengthRegex = /^.{8,}$/;
    
        // Ensure one or more symbols
        const symbolRegex = /[\W_]/;
    
        // Ensure one or more numeric fields
        const numericRegex = /\d/;
    
        // Ensure one or more Upper Case Alphanumeric Characters
        const upperCaseRegex = /[A-Z\d]/;
    
        // Ensure one or more Lower Case Alphanumeric Characters
        const lowerCaseRegex = /[a-z\d]/;
    
        // Check all conditions
        return (
            lengthRegex.test(password) &&
            symbolRegex.test(password) &&
            numericRegex.test(password) &&
            upperCaseRegex.test(password) &&
            lowerCaseRegex.test(password)
        );
    }
 

    const SignInComponent = () => (
        <Grid item xs={12} className={classes.paperRoot}>
            <div className={classes.paper}>
                <div className={classes.logoContainer}>
                    <div className={classes.logoBackground}>
                        <img 
                            src={SmartInvoicingLogo} 
                            alt="Smart Invoicing" 
                            className={classes.logo}
                        />
                    </div>
                </div>
                <div className={classes.securityBadge}>
                    <SecurityIcon />
                    <span>Secure Login Portal</span>
                </div>
                {/* <img src={companyLogo} class="image--cover--sign" /> */}
                <Typography component="h1" variant="h5" className={classes.title  }>
                    Welcome Back
                </Typography>
                <form className={classes.form} onSubmit={handleSignInSubmit}>
                    <FormControl variant="outlined" fullWidth margin="normal" className={classes.select}>
                        <InputLabel id="companyid-label" shrink>Select Company *</InputLabel>
                        <Select
                            labelId="companyid-label"
                            id="companyid"
                            value={company[0]?.CompanyID}
                            autoFocus={true}
                            variant="outlined"
                            margin="normal"
                            name='companyid'
                            labelWidth={250}
                            label='Select Company *'
                            required
                            fullWidth
                            disabled={true}
                            MenuProps={menuProps}
                        >
                            {
                                company?.length > 0 ?
                                company.map((val, index) => {
                                    return(
                                        <MenuItem 
                                            key={index} 
                                            value={val.CompanyID}
                                            style={{
                                                color: '#ffffff',
                                                backgroundColor: 'transparent',
                                                borderRadius: '8px',
                                                margin: '2px 4px',
                                                padding: '10px 16px',
                                                fontSize: '14px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                            }}
                                        >
                                            {val.CompanyName}
                                        </MenuItem>
                                    )
                                })
                                : null
                            }
                        </Select>
                    </FormControl>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="User Name"
                        name="username"
                        autoComplete="username"
                        className={classes.textField}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        className={classes.textField}
                    />
                    <div className='button_container'>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            fullWidth
                        >
                            Sign In
                        </Button>
                    </div>
                    <Box mt={3}>
                        {authFail && (
                            <Alert 
                                elevation={6} 
                                variant="filled" 
                                severity="error"
                                sx={{
                                    backgroundColor: 'rgba(244, 67, 54, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(244, 67, 54, 0.3)',
                                    borderRadius: '12px',
                                    color: '#ffffff'
                                }}
                            >
                                Incorrect Username or Password or Company
                            </Alert>
                        )}
                    </Box>
                </form>
            </div>
        </Grid>
    );

    const ResetPasswordComponent = () => (
        <Grid item xs={12} className={classes.paperRoot}>
            <div className={classes.paper}>
                <div className={classes.logoContainer}>
                    <div className={classes.logoBackground}>
                        <img 
                            src={SmartInvoicingLogo} 
                            alt="Smart Invoicing" 
                            className={classes.logo}
                        />
                    </div>
                </div>
                <div className={classes.securityBadge}>
                    <SecurityIcon />
                    <span>Email Verification</span>
                </div>
                <Typography component="h1" variant="h5" className={classes.title}>
                    Verify Your Email
                </Typography>
                <form className={classes.form} onSubmit={handleResetPassword}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="User Name"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        className={classes.textField}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        type="email"
                        name="email"
                        autoComplete="email"
                        className={classes.textField}
                    />
                    <div className='button_container' style={{display: 'flex', gap: '12px'}}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            style={{flex: 1}}
                        >
                            Verify
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={backClickHandler}
                            style={{flex: 1}}
                        >
                            Back
                        </Button>
                    </div>
                    <Box mt={3}>
                        {authFail && (
                            <Alert 
                                elevation={6} 
                                variant="filled" 
                                severity="error"
                                sx={{
                                    backgroundColor: 'rgba(244, 67, 54, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(244, 67, 54, 0.3)',
                                    borderRadius: '12px',
                                    color: '#ffffff'
                                }}
                            >
                                Provided Email did not match our records
                            </Alert>
                        )}
                    </Box>
                </form>
            </div>
        </Grid>
    );

    const ChangePasswordComponent = () => (
        <Grid item xs={12} className={classes.paperRoot}>
            <div className={classes.paper}>
                <div className={classes.logoContainer}>
                    <div className={classes.logoBackground}>
                        <img 
                            src={SmartInvoicingLogo} 
                            alt="Smart Invoicing" 
                            className={classes.logo}
                        />
                    </div>
                </div>
                <div className={classes.securityBadge}>
                    <SecurityIcon />
                    <span>Password Change</span>
                </div>
                <Typography component="h1" variant="h5" className={classes.title}>
                    Change Your Password
                </Typography>
                <form className={classes.form} onSubmit={handleChangePassword}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        type='password'
                        fullWidth
                        name="newPassword"
                        label="New Password"
                        id="newPassword"
                        autoComplete="current-password"
                        className={classes.textField}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="rePassword"
                        label="Re-enter Password"
                        type="password"
                        id="rePassword"
                        autoComplete="current-password"
                        className={classes.textField}
                    />
                    <div className='button_container'>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            fullWidth
                        >
                            Change Password
                        </Button>
                    </div>
                    <Box mt={3}>
                        {!passMatch && (
                            <Alert 
                                elevation={6} 
                                variant="filled" 
                                severity="error"
                                sx={{
                                    backgroundColor: 'rgba(244, 67, 54, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(244, 67, 54, 0.3)',
                                    borderRadius: '12px',
                                    color: '#ffffff'
                                }}
                            >
                                Passwords Don't Match
                            </Alert>
                        )}
                    </Box>
                </form>
            </div>
        </Grid>
    );

    const getUserAccessList = (userId,CompanyID) => {
        if (userId  || userId == '0') {
            securityService.getUserAccessList(userId,CompanyID)
                .then((response) => {
                    console.log('response: ', response);
                    if (response?.data?.recordset?.length === 0) {
                        console.log('No security items found: ');
                    }
                    else {
                        console.log(JSON.stringify(response?.data?.recordset));
                        localStorage.setItem('userAccessList', JSON.stringify(response?.data?.recordset));
                    }
                    linkElem.current.click()
                });
        }
        else {
            console.log('could not read user id: ');
        }
    };

    const getFurtherTaxValue = (userID,CompanyID) => {
        console.log(CompanyID)
        if(CompanyID){
            securityService.getFurtherTaxValue(CompanyID)
                .then((response) => {
                    console.log('response: ', response);
                    console.log('response: ',  response?.data?.FurtherTaxDefaultPercent);
                    localStorage.setItem('FurtherTaxValue', response?.data?.FurtherTaxDefaultPercent || 0);
                    getUserAccessList(userID,CompanyID);
                    
                });
        }
        else {
            console.log('could not read user id: ');
            localStorage.setItem('FurtherTaxValue', 0);
            getUserAccessList(userID,CompanyID);
        }
    };

    return (
        <Grid container component="main" className={`${classes.root} hal-auth-form-wrapper`}>
            <CssBaseline />
            <Grid item xs={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {isResetPassScreen ?
                    <ResetPasswordComponent />
                    : isChangePassScreen ?
                        <ChangePasswordComponent /> :
                        <SignInComponent />
                }
            </Grid>
            <Link href='/SaleInvoice' variant="body2" ref={linkElem}> </Link>
            {FooterStyle}
        </Grid>
    );
}
    